<form class="flex flex-col gap-6" (submit)="submit($event)">
  <div class="flex flex-col gap-3">
    <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">Finish your account</h1>
    <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">
      @if (onboarding.draft().authMode === 'google') {
        Add your name so we can set up {{ onboarding.brandName() }}.
      } @else {
        Add your name and a password to claim {{ onboarding.brandName() }}.
      }
    </p>
  </div>

  <div class="flex flex-col gap-2">
    <label for="vf-first-name" class="text-base font-bold">First name</label>
    <input id="vf-first-name" type="text" autocomplete="given-name" class="h-14 rounded-lg border border-border bg-card px-4 text-lg text-foreground outline-none placeholder:text-muted-foreground focus:border-primary focus:ring-2 focus:ring-primary/20" [value]="onboarding.draft().firstName" (input)="onFirstName($event)" />
  </div>
  <div class="flex flex-col gap-2">
    <label for="vf-last-name" class="text-base font-bold">Last name</label>
    <input id="vf-last-name" type="text" autocomplete="family-name" class="h-14 rounded-lg border border-border bg-card px-4 text-lg text-foreground outline-none placeholder:text-muted-foreground focus:border-primary focus:ring-2 focus:ring-primary/20" [value]="onboarding.draft().lastName" (input)="onLastName($event)" />
  </div>

  @if (onboarding.draft().authMode !== 'google') {
    <div class="flex flex-col gap-2">
      <label for="vf-password" class="text-base font-bold">Password</label>
      <div class="flex gap-2">
        <input
          id="vf-password"
          [type]="passwordVisible() ? 'text' : 'password'"
          autocomplete="new-password"
          class="h-14 min-w-0 flex-1 rounded-lg border border-border bg-card px-4 text-lg text-foreground outline-none placeholder:text-muted-foreground focus:border-primary focus:ring-2 focus:ring-primary/20"
          [value]="password()"
          (input)="onPassword($event)" />
        <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary shrink-0" (click)="togglePassword()">
          {{ passwordVisible() ? 'Hide' : 'Show' }}
        </button>
      </div>
    </div>
  }

  @if (onboarding.error()) {
    <p class="m-0 text-base font-semibold text-red-600 dark:text-red-400" role="alert">{{ onboarding.error() }}</p>
  }

  <div class="fixed inset-x-0 bottom-0 z-20 border-t border-border bg-background px-5 py-3 sm:static sm:z-auto sm:border-0 sm:bg-transparent sm:p-0">
    <button type="submit" class="btn-shout btn-shout-md btn-shout-primary w-full justify-center" [disabled]="onboarding.registering()">
      @if (onboarding.registering()) {
        <span class="size-4 animate-spin rounded-full border-2 border-white/40 border-t-white" aria-hidden="true"></span>
        Creating your account…
      } @else {
        Create account →
      }
    </button>
  </div>
</form>
